import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { PermissionService } from 'src/app/service/permission.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
// const moment = _rollupMoment || _moment;
const moment = require('moment');

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'dddd, MMMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-schedule-meeting-popup',
  templateUrl: './schedule-meeting-popup.component.html',
  styleUrls: ['./schedule-meeting-popup.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class ScheduleMeetingPopupComponent implements OnInit {
  meetingInfo: any;
  meetingDate :any ;
  private readonly notifier!: NotifierService;
  meetingJSON: any;
  currentDate!: Date;
  constructor(private permissionService:PermissionService,private sideNav : SideNavServiceService,private meetingService:MeetingService,private globals:Globals,private datepipe: DatePipe, private matDialogRef: MatDialogRef<ScheduleMeetingPopupComponent>,@Inject(MAT_DIALOG_DATA) data: any,private util:UtilityService) { 
    this.meetingInfo = data ;
    this.setData();
    //
  }
  reschedule = new UntypedFormGroup({
    meetingTitle: new UntypedFormControl(''),
    meetingStartTime: new UntypedFormControl('', [Validators.required, Validators.minLength(5)]),
    meetingDateStr: new UntypedFormControl(''),
    orgCode: new UntypedFormControl(''),
    visitorTimeZone: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    reschedule :new UntypedFormControl('')
  });

  setData(){
    this.reschedule.controls['meetingStartTime'].setValue(this.meetingInfo.meetingData.meetingStartTime);
    this.reschedule.controls['meetingDateStr'].setValue(moment(this.meetingInfo.meetingData.meetingDateStr));
    this.reschedule.controls['meetingTitle'].setValue(this.meetingInfo.meetingData.meetingTitle);
    this.reschedule.controls['orgCode'].setValue(this.globals.orgCode);
    this.reschedule.controls['visitorTimeZone'].setValue(this.globals.vTimeZone);
    this.reschedule.controls['userId'].setValue(this.globals.userId);
    this.reschedule.controls['reschedule'].setValue('Y');

    // this.meetingDate.setValue(this.meetingInfo.meetingData.meetingDateStr);

  }

  ngOnInit(): void {
  }
  ngDoCheck(): void {
    this.currentDate=new Date();
   }
 

  closeDialog() {
    this.matDialogRef.close(false)
  }
  rescheduleMeeting(){
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.POSTPONEMEETING,this.util.permissionType.READ);
    
    if(!accessFlag){
      return;
    }
    this.meetingJSON = {
      "meetingId" : this.meetingInfo.meetingData.meetingId,
      "userId": this.globals.userId,
      "rescheduleFlag":"Y",
      "visitorTimeZone":this.globals.vTimeZone
    }
    if(this.meetingInfo.meetingData.meetingStartTime == this.reschedule.controls['meetingStartTime'].value && this.meetingInfo.meetingData.meetingDateStr == this.datepipe.transform(this.reschedule.controls['meetingDateStr'].value,'EEEE, MMMM dd, yyyy')){
      this.meetingJSON.isMeetingModified ="";
    }else{
      this.meetingJSON.isMeetingModified ="Y";
    }
    var resscheduleDate= this.datepipe.transform(this.reschedule.controls['meetingDateStr'].value, "MMM dd, YYYY");
    this.reschedule.controls['meetingDateStr'].setValue(resscheduleDate);
    //
    this.meetingService.updateMeeting(this.meetingInfo.meetingData.meetingId, this.reschedule.value).subscribe(responsedata => {
      if(this.util.nvl(this.meetingInfo.meetingData.meetingFrequency)!="" && this.util.nvl(this.meetingInfo.meetingData.meetingFrequency)!="N" && this.util.nvl(this.meetingInfo.meetingData.recurVisibleFlag)=="" && this.util.nvl(this.meetingInfo.meetingData.recurTillDateAsMilliSec)!=""){
        this.createRecurParentMeeting(this.meetingJSON);
      }else{
        this.meetingService.scheduleMeeting(this.meetingJSON).subscribe(res => {
          this.sideNav.alertReschedule("reschedule");
        });
      }

    });
    this.matDialogRef.close();

  }


  createRecurParentMeeting(meetingJSON:any){
    this.meetingService.createRecurParentMeeting(meetingJSON).subscribe(res => {
      this.meetingService.scheduleMeeting(this.meetingJSON).subscribe(res => {
        this.sideNav.alertReschedule("reschedule");
      });
    }).add(() => {
      
    });
  }

}


